module.exports = __webpack_public_path__ + "img/img (25).e8a5ea35.jpg";